<template>
  <MDBRow class="mb-4"
    ><MDBCol>
      <MDBBtn color="dark" @click="moveArea" style="float: left">
        <MDBIcon icon="long-arrow-alt-left" iconStyle="fas" /> Back to Area
      </MDBBtn>
    </MDBCol>
  </MDBRow>
  <div v-if="correct">
    <p class="note note-primary">
      <strong>{{ areaName }}</strong>
    </p>
    <div v-if="!newmap" class="area-container">
      <div v-for="i in 8" :key="i">
        <MDBCard
          text="white"
          bg="black"
          class="node side-stage w-50 click-card"
          :class="{
            hidden: map[0][i - 1] == false,
            active: stage == map[0][i - 1]['title'],
          }"
          @click="setCurrent(map[0][i - 1]['title'])"
        >
          <MDBCardImg :src="'images/B Stage.png'" top />
          <MDBCardBody>
            <div
              class="stage-name"
              :class="{ active: isActive(map[0][i - 1]['title']) }"
            >
              {{ map[0][i - 1]["name"] }}
            </div>
          </MDBCardBody>
        </MDBCard>
      </div>
      <div v-for="i in 8" :key="i">
        <MDBCard
          text="white"
          bg="black"
          class="node main-stage w-50 click-card"
          :class="{
            hidden: map[1][i - 1] == false,
            active: stage == map[1][i - 1]['title'],
          }"
          @click="setCurrent(map[1][i - 1]['title'])"
        >
          <MDBCardImg :src="'images/Main Stage.png'" top />
          <MDBCardBody>
            <div
              class="stage-name"
              :class="{ active: isActive(map[1][i - 1]['title']) }"
            >
              {{ map[1][i - 1]["name"] }}
            </div>
          </MDBCardBody>
        </MDBCard>
      </div>
      <div v-for="i in 8" :key="i">
        <MDBCard
          text="white"
          bg="black"
          class="node ex-stage w-50 click-card"
          :class="{
            hidden: map[2][i - 1] == false,
            active: stage == map[2][i - 1]['title'],
          }"
          @click="setCurrent(map[2][i - 1]['title'])"
        >
          <MDBCardImg :src="'images/EX Stage.png'" top />
          <MDBCardBody>
            <div
              class="stage-name"
              :class="{ active: isActive(map[2][i - 1]['title']) }"
            >
              {{ map[2][i - 1]["name"] }}
            </div>
          </MDBCardBody>
        </MDBCard>
      </div>
    </div>
    <div v-else :style="'grid-template-columns: repeat('+mapsize[0]+',minmax(128px,1fr));'" class="area-container-new">
      <template  v-for="i in mapsize[1]" :key="i">
      <div v-for="j in mapsize[0]" :key="j">
        <MDBCard
          text="white"
          bg="black"
          class="node w-50 click-card"
          :class="{
            hidden: newmap[i-1][j - 1] == false,
            active: stage == newmap[i-1][j - 1]['title'],
            'ex-stage': i % 2 == 1,
            'main-stage': i % 2 == 0,
          }"
          @click="setCurrent(newmap[i-1][j - 1]['title'])"
        >
          <MDBCardImg :src="'images/' + newmap[i-1][j - 1]['type'] + ' Stage.png'" top />
          <MDBCardBody>
            <div
              class="stage-name"
              :class="{ active: isActive(newmap[i-1][j - 1]['title']) }"
            >
              {{ newmap[i-1][j - 1]["name"] }}
            </div>
          </MDBCardBody>
        </MDBCard>
      </div>
      </template>
    </div>
    <enemy-stage :enemy="activeStage" v-if="activeStage" />
  </div>
  <div v-else>Wrong Name</div>
  <enemy-tab
    :enemy="this.activeEnemy[0]"
    :lvl="this.activeEnemy[1]"
    @update="updateEvent"
  />
</template>

<script>
import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBCard,
  MDBCardBody,
  // MDBCardText,
  MDBCardImg,
  MDBBtn,
} from "mdb-vue-ui-kit";
// import { useStore } from "vuex";
import EnemyStage from "../components/EnemyStage.vue";
import EnemyTab from "../components/EnemyTab.vue";
export default {
  name: "Area",
  components: {
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBCard,
    MDBCardBody,
    // MDBCardText,
    MDBCardImg,
    MDBBtn,
    EnemyStage,
    EnemyTab,
  },
  computed: {
    maps() {
      return this.$store.getters.getMaps;
    },
    correct() {
      if (this.zone < 0) {
        return false;
      }
      if (this.area in this.maps) {
        if (this.zone < this.maps[this.area]["zones"].length) {
          return true;
        }
      }
      return false;
    },
    newmap() {
      if (this.correct) {
        if (this.maps[this.area]["zones"][this.zone].newmap) {
          let check = [

          ];
          let temp = this.maps[this.area]["zones"][this.zone].gridsize
          for (let i = 0; i < temp[1]; i++) {
            let row = []
            for (let j = 0; j < temp[0]; j++) {
              row.push(false)
            }
            check.push(row)
          }
      let map = this.maps[this.area]["zones"][this.zone]["stage"];
      for (var s in map) {
        let g = map[s]["grid"];
        check[g[1]][g[0]] = map[s];
      }
      return check;
        }
      }
      return false;
    },
    mapsize() {
      if (this.correct) {
        if (this.maps[this.area]["zones"][this.zone].newmap) {
          return this.maps[this.area]["zones"][this.zone].gridsize
        }
      }
        return false
    },
    areaName() {
      return this.maps[this.area]["zones"][this.zone]["title"];
    },
    map() {
      let check = [
        [false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false],
      ];
      let map = this.maps[this.area]["zones"][this.zone]["stage"];
      for (var s in map) {
        let g = map[s]["grid"];
        check[g[1]][g[0]] = map[s];
      }
      return check;
    },
    activeStage() {
      if (this.correct) {
        let map = this.maps[this.area]["zones"][this.zone]["stage"];
        for (var s in map) {
          if (map[s]["title"] == this.stage) {
            return map[s];
          }
        }
      }
      return false;
    },
    activeEnemy() {
      return this.$store.getters.getActiveEnemy;
    },
  },
  data() {
    return {
      area: this.$route.params.area,
      zone: parseInt(this.$route.params.zone) - 1,
      stage: this.$route.params.stage,
    };
  },
  created() {
    document.title = "Zone";
  },
  methods: {
    setCurrent(id) {
      // console.log(id);
      this.stage = id
    },
    updateEvent(e) {
      if (e == false) {
        this.$store.dispatch("setActiveEnemy", ["", 0]);
      }
    },
    isActive(title) {
      if (this.stage == title) {
        return true;
      }
      return false;
    },
    moveArea() {
      this.$router.push("/world/" + this.area);
    },
  },
};
</script>

<style scoped>
.col {
  width: 12.5%;
}
.col img {
  max-width: 100%;
}
.side-stage,
.ex-stage {
  float: right;
}
.main-stage {
  float: left;
}
.area-container {
  background-color: black;
  padding: 1em;
  display: inline-grid;
  gap: 0.75em;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(3, 1fr);
  width: 100%;
}
.area-container-new {
  background-color: black;
  padding: 1em;
  display: inline-grid;
  gap: 0.75em;
  grid-template-rows: repeat(3, 1fr);
  overflow-x: auto;
  width: 100%;
}
.area-container-new-8 {
  background-color: black;
  padding: 1em;
  display: inline-grid;
  gap: 0.75em;
  grid-template-columns: repeat(8,minmax(128px,1fr));
  grid-template-rows: repeat(3, 1fr);
  overflow-x: auto;
  width: 100%;
}
.area-container-new-10 {
  background-color: black;
  padding: 1em;
  display: inline-grid;
  gap: 0.75em;
  grid-template-columns: repeat(10,minmax(128px,1fr));
  grid-template-rows: repeat(3, 1fr);
  overflow-x: auto;
  width: 100%;
}
.area-container-new-18 {
  background-color: black;
  padding: 1em;
  display: inline-grid;
  gap: 0.75em;
  grid-template-columns: repeat(18,minmax(128px,1fr));
  grid-template-rows: repeat(3, 1fr);
  overflow-x: auto;
  width: 100%;
}
.area-container .row {
  min-height: 33%;
  height: 33%;
}
.stage-name {
  color: yellow;
}
.stage-name.active {
  background-color: maroon;
}
.hidden {
  visibility: hidden;
}
.card-body {
  padding: 0;
  font-size: 12px;
}
</style>
